import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AppProvider, useApp } from "./context/AppContext";
import { Layout } from "./components/Layout";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import MeetingDetail from "./pages/MeetingDetail";
import Recording from "./pages/Recording";
import Search from "./pages/Search";
import Settings from "./pages/Settings";
import LiveTranslation from "./pages/LiveTranslation";
import LiveSessionSummary from "./pages/LiveSessionSummary";
import FaceToFaceMode from "./pages/FaceToFaceMode";
import AdminConfig from "./pages/AdminConfig";

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated } = useApp();
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  return children;
};

// Public Route Component (redirect if authenticated)
const PublicRoute = ({ children }) => {
  const { isAuthenticated } = useApp();
  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }
  return children;
};

const AppRoutes = () => {
  return (
    <Routes>
      {/* Public Routes */}
      <Route
        path="/"
        element={
          <Layout>
            <Landing />
          </Layout>
        }
      />
      <Route
        path="/login"
        element={
          <PublicRoute>
            <Layout>
              <Login />
            </Layout>
          </PublicRoute>
        }
      />
      {/* Rejestracja zamknieta — konta zaklada administrator */}
      <Route path="/register" element={<Navigate to="/login" replace />} />

      {/* Protected Routes */}
      <Route
        path="/dashboard"
        element={
          <ProtectedRoute>
            <Layout>
              <Dashboard />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/meeting/:id"
        element={
          <ProtectedRoute>
            <Layout>
              <MeetingDetail />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/recording"
        element={
          <ProtectedRoute>
            <Layout>
              <Recording />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/search"
        element={
          <ProtectedRoute>
            <Layout>
              <Search />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/settings"
        element={
          <ProtectedRoute>
            <Layout>
              <Settings />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/live"
        element={
          <ProtectedRoute>
            <Layout>
              <LiveTranslation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/live/:sessionId"
        element={
          <ProtectedRoute>
            <Layout>
              <LiveTranslation />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/live/:sessionId/summary"
        element={
          <ProtectedRoute>
            <Layout>
              <LiveSessionSummary />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/live/session/:sessionId"
        element={
          <ProtectedRoute>
            <Layout>
              <LiveSessionSummary />
            </Layout>
          </ProtectedRoute>
        }
      />
      <Route
        path="/live/face-to-face"
        element={
          <ProtectedRoute>
            <FaceToFaceMode />
          </ProtectedRoute>
        }
      />

      {/* Admin */}
      <Route
        path="/admin/config"
        element={
          <ProtectedRoute>
            <Layout>
              <AdminConfig />
            </Layout>
          </ProtectedRoute>
        }
      />

      {/* Fallback */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
};

function App() {
  return (
    <AppProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster position="top-right" richColors />
      </BrowserRouter>
    </AppProvider>
  );
}

export default App;
